module.exports = __webpack_public_path__ + "static/ahptuslogo.cea6e305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ahptuslogo.jpg
// module id = 527
// module chunks = 117206707316740